<template>
  <div class="regra-concatenacao">
    <div class="bloco-label">Monte o valor concatenando as partes abaixo</div>
    <div class="info-arrasto">A ordem das partes define o resultado. Arraste pelo <fa-icon icon="grip-vertical" /> para reordenar.</div>

    <draggable
      :list="regra.partes"
      handle=".drag-handle"
      animation="200"
      ghost-class="parte-linha--dragging"
      @end="emit"
    >
      <div v-for="(parte, idx) in regra.partes" :key="idx" class="parte-linha">
        <span class="drag-handle" v-if="regra.partes.length > 1" title="Arraste para reordenar" aria-label="Arraste para reordenar">
          <fa-icon icon="grip-vertical" />
        </span>
        <span class="ordem">#{{ idx + 1 }}</span>
        <ExpressaoValor :value="parte" :campos="campos" @input="alterar(idx, $event)" placeholder="Texto literal" />
        <button
          type="button"
          class="btn-mini btn-mini--danger"
          v-if="regra.partes.length > 1"
          @click="remover(idx)"
          title="Remover parte"
          aria-label="Remover parte"
        >
          <fa-icon icon="trash-alt" />
        </button>
      </div>
    </draggable>

    <button type="button" class="btn-add-inline" @click="adicionar">
      <fa-icon icon="plus" /> Adicionar parte
    </button>

    <div class="opcoes-row">
      <div class="opt">
        <label class="field-label">Separador entre partes</label>
        <input class="form-control form-control-sm" type="text" v-model="regra.separador" placeholder="(vazio)" />
      </div>
      <div class="opt">
        <label class="field-label">Ignorar partes vazias</label>
        <select class="form-control form-control-sm" v-model="regra.ignorar_vazios">
          <option :value="false">Não</option>
          <option :value="true">Sim</option>
        </select>
      </div>
    </div>

    <div class="preview" v-if="preview">
      <span class="preview-label">Pré-visualização:</span>
      <code>{{ preview }}</code>
    </div>
  </div>
</template>

<script>
import ExpressaoValor from "./ExpressaoValor";
import draggable from "vuedraggable";

export const regraConcatenacaoVazia = () => ({
  tipo: "concatenacao",
  separador: "",
  ignorar_vazios: false,
  partes: [{ tipo: "literal", valor: "" }],
});

export default {
  name: "RegraConcatenacao",
  components: { ExpressaoValor, draggable },
  props: {
    value: { type: Object, required: true },
    campos: { type: Array, default: () => [] },
  },
  computed: {
    regra() {
      return this.value;
    },
    preview() {
      if (!this.regra.partes || this.regra.partes.length === 0) return "";
      const sep = this.regra.separador || "";
      return this.regra.partes
        .map((p) => (p.tipo === "literal" ? p.valor || "" : `{${p.caminho || "?"}}`))
        .join(sep);
    },
  },
  methods: {
    emit() {
      this.$emit("input", { ...this.regra });
    },
    adicionar() {
      this.regra.partes.push({ tipo: "literal", valor: "" });
      this.emit();
    },
    remover(idx) {
      this.regra.partes.splice(idx, 1);
      this.emit();
    },
    alterar(idx, expr) {
      this.$set(this.regra.partes, idx, expr);
      this.emit();
    },
  },
};
</script>

<style scoped>
.regra-concatenacao { display: flex; flex-direction: column; gap: 8px; }
.bloco-label {
  font-size: 11px; font-weight: 600; color: var(--text-muted);
  text-transform: uppercase; letter-spacing: 0.3px;
}
.opcoes-row {
  display: flex; gap: 12px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed var(--border-default);
}
.opt { flex: 1; max-width: 220px; }
.field-label {
  font-size: 11px; font-weight: 600; color: var(--text-muted);
  text-transform: uppercase; margin-bottom: 3px; display: block;
}
.parte-linha {
  display: flex; align-items: flex-start; gap: 8px; padding-top: 22px;
}
.ordem {
  font-size: 11px; font-weight: 600; color: var(--text-muted);
  background: var(--border-default); padding: 1px 6px; border-radius: 4px;
}
.btn-add-inline {
  background: none; border: none; color: var(--primary);
  font-size: 12px; padding: 4px 0;
  cursor: pointer; align-self: flex-start; margin-top: 4px;
}
.btn-add-inline:hover { text-decoration: underline; }
.btn-mini {
  background: none; border: none; cursor: pointer; color: var(--text-subtle);
  padding: 2px 6px; border-radius: 4px;
}
.btn-mini--danger:hover { color: var(--danger); background: var(--danger-bg); }
.preview {
  margin-top: 6px;
  padding: 8px 12px;
  background: var(--bg-subtle);
  border: 1px solid var(--border-default);
  border-radius: 6px;
  font-size: 12px;
}
.preview-label { color: var(--text-muted); margin-right: 8px; }
.preview code { color: var(--text-strong); background: #fff; padding: 1px 6px; border-radius: 4px; }
.info-arrasto {
  font-size: 11px; color: var(--text-subtle); margin-bottom: 4px;
}
.drag-handle {
  cursor: grab;
  color: var(--text-subtle);
  padding: 0 4px;
  font-size: 12px;
}
.drag-handle:active { cursor: grabbing; }
.parte-linha--dragging { opacity: 0.4; }

@media (max-width: 767.98px) {
  .opcoes-row { flex-direction: column; }
  .opt { max-width: 100%; }
}
</style>
